module.exports = __webpack_public_path__ + "static/media/projects.fivethirtyeight.com_election-2016_primary-forecast_plot.7ce94a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/projects.fivethirtyeight.com_election-2016_primary-forecast_plot.png
// module id = 418
// module chunks = 0